import { toBoolean } from '../../../../core/utils/lp-backend';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.qr_typing`. */
export const editQRTyping = async (qr_typing: boolean): Promise<any> =>
  writeSettingsFields({ qr_typing: toBoolean(qr_typing) });
